import { createRouter, createWebHistory } from 'vue-router';
import SinglePage from '../components/pages/SinglePage';
import HomePage from '../components/pages/HomePage';
import AboutPage from '../components/pages/AboutPage';
import FuturePage from '../components/pages/FuturePage';
import ArticlePage from '../components/pages/ArticlePage';
import NotFoundPage from '../components/pages/NotFoundPage';
import CategoryListPage from '../components/pages/CategoryListPage';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
    meta: {
      lightTheme: false,
      isTransparentBg: true,
      resizeLogo: true,
    },
  },
  {
    path: '/about',
    name: 'about',
    component: AboutPage,
    meta: {
      lightTheme: false,
      isTransparentBg: true,
      resizeLogo: false,
    },
  },
  {
    path: '/communes',
    name: 'communes',
    component: CategoryListPage,
    meta: {
      lightTheme: true,
      resizeLogo: false,
    },
  },
  {
    path: '/projects',
    name: 'projects',
    component: CategoryListPage,
    meta: {
      lightTheme: true,
      resizeLogo: false,
    },
  },
  {
    path: '/builders',
    name: 'builders',
    component: CategoryListPage,
    meta: {
      lightTheme: true,
      resizeLogo: false,
    },
  },
  {
    path: '/building-types',
    name: 'building-types',
    component: CategoryListPage,
    meta: {
      lightTheme: true,
      resizeLogo: false,
    },
  },
  {
    path: '/communes/:id',
    name: 'communesSingle',
    component: SinglePage,
    meta: {
      lightTheme: true,
      resizeLogo: false,
    },
  },
  {
    path: '/projects/:id',
    name: 'projectsSingle',
    component: SinglePage,
    meta: {
      lightTheme: true,
      resizeLogo: false,
    },
  },
  {
    path: '/builders/:id',
    name: 'buildersSingle',
    component: SinglePage,
    meta: {
      lightTheme: true,
      resizeLogo: false,
    },
  },
  {
    path: '/future',
    name: 'future',
    component: FuturePage,
    meta: {
      lightTheme: false,
      isTransparentBg: true,
      resizeLogo: false,
    },
  },
  {
    path: '/article/:id',
    name: 'article',
    component: ArticlePage,
    meta: {
      lightTheme: false,
      isTransparentBg: true,
      resizeLogo: false,
    },
  },
  {
    path: '/:catchAll(.*)',
    name: 'notFound',
    component: NotFoundPage,
    meta: {
      lightTheme: false,
      smallerLogo: false,
    },
    beforeEnter: (to, from, next) => {
      if (to.path.startsWith('/api')) {
        next(false);
      } else {
        next();
      }
    },
  },
  {
    path: '/:catchAll(.*)*',
    name: 'notFound',
    component: NotFoundPage,
    meta: {
      lightTheme: false,
      smallerLogo: false,
    },
    beforeEnter: (to, from, next) => {
      if (to.path.startsWith('/api')) {
        next(false);
      } else {
        next();
      }
    },
  },
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
});

export default router;
